/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td
let entidad;
export const tableDetail = {
    entity: 'customerProfit',//name table on the db
    dest: 'customerProfit',//name of the entity on the system

    // action for body: represent the data-detail as an object and provide a getter
    tdDataDetailObj: {
        click: [
            { dest: "ripple" },
            { dest: null, elem: "fullcont", id: "customerProfit-fullcont", act: "callData", dbid: "#dbid" },
            { dest: "customerProfit", elem: "fullcont", id: "customerProfit-fullcont", act: "callUnpaidInvoices", dbid: "#dbid" }
        ],
        clickRight: [
            { dest: "customerProfit", elem: "dt", act: "trMenu", id: "trMenu", entity: "report", dbid: "#dbid" }
        ]
    },

    // returns the serialized `data-detail` string with the provided entity inserted
    getTdDataDetail(ent, id) {
    const obj = JSON.parse(JSON.stringify(this.tdDataDetailObj));

    obj.click[1].dest = ent;
    obj.click[1].id   = `${ent}-fullcont`;
    obj.click[1].dbid = id;

    obj.click[2].dest = ent;
    obj.click[2].id   = `${ent}-fullcont`;
    obj.click[2].dbid = id;

    obj.clickRight[0].dest = ent;
    obj.clickRight[0].dbid = id;

    return `data-detail='${JSON.stringify(obj)}'`;
},

    // getter so existing code can read `tableDetail.tdDataDetail` as before
    get tdDataDetail() {
        return this.getTdDataDetail(this.dest);
    },

    filter: {
        mainFilterFields: [""],
        mainFilterValues: ["", ""],
        andFilterFields: [""],
        andFilterValues: [""],
    }
}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) { //console.log('organizeRow>')
    var newData = []

    if (data.length === 0) {
        newData.push({
            id: 'nothing',
            tdDataDetail: tableDetail.getTdDataDetail(tableDetail.dest),
            colum: [{ label: 'No Results', span: '' },
            { label: '', span: '' },
            { label: '', span: '' },]
        })
        return newData
    }

    if (data[0].customer_id != null) {
        tableDetail.entity = "customerProfit"
        tableDetail.dest = "customerProfit"
    } else {
        tableDetail.entity = "providerProfit"
        tableDetail.dest = "providerProfit"
    }

    data.forEach((elem) => {
        const rowId = elem.customer_id || elem.provider_id;
        newData.push(
            {
                id: rowId,
                tdDataDetail: tableDetail.getTdDataDetail(tableDetail.dest, rowId),
                colum: [{
                    label: elem.customer_name || elem.provider_name,
                    span: elem.total_earnings,
                    style: {
                        tdClass: "tdWithAvatar",
                        avatar: elem.avatar,
                        avatarColor: elem.avatarColor,
                        avatarColorLetter: elem.avatarColorLetter,
                        avatarLetter: elem.avatarLetter,
                    }
                },
                { label: elem.roi_last_month, span:elem.total_last_month },
                { label: elem.roi_last_6_months, span:elem.total_last_6_months },
                { label: elem.roi_last_year, span:elem.total_last_year },
                { label: elem.roi_total},
                ]
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/